(ns web3.routers.app-helpers
  (:require [web3.routing.core :as routing]
            [web3.persistence.current-property :as current-property]))

(defn file-collection-href
  [k]
  (routing/path-for [:files/collection
                     :property-id (current-property/get-id)
                     :collection (name k)]))


(defn details-href
  ([] (details-href nil))
  ([content]
   (routing/path-for :router/content-modal
                     (when content
                       (->> (select-keys content [:id :__typename])
                            (routing/make-route-kargs :type/detail)))
                     :router/form-modal nil)))

(defn parent-href
  [{:keys [id __typename] :as parent}]
  (case __typename
    "Property"
    (routing/path-for
      {:router/root [:home/property
                     :property-id (current-property/get-id)]})
    "AssetGroup"
    (routing/path-for
      {:router/root [:group :property-id (current-property/get-id) :group-id id]})
    "Asset"
    (details-href parent)
    nil))

(def add-end-href
  (partial routing/conj-segment :router/form-modal "add-end"))

(def select-parent-href
  (partial routing/conj-segment :router/form-modal "select-parent"))

(def nameplate-locator-href
  (partial routing/conj-segment :router/form-modal "nameplate-locator"))
